import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";

export interface SignInSalihaRequest {
    Login: {
        EmailAddr: string;
        Password: string;
    }
}

export interface SignInSalihaResponse {
    Login: {
        status: number;
        data: {
            userid: string;
            nama: string;
            email_addr: string;
            role: string;
            unik_id: string;
        }
        token: string;
    }
}

export interface SignUpSalihaRequest {
    REGISTER: {
        emailAddr: string;
        nama: string;
        role: string;
        password: string;
    }
}

export interface SignUpSalihaResponse {
    REGISTER: {
        status: number;
        data: {
            userid: string;
            nama: string;
            email_addr: string;
            role: string;
            unik_id: string;
        }
        token: string;
    }
}

export interface UserInfoSalihaResponse {
    status: boolean;
    message: string;
    data: {
        email: string;
        password: string;
    }
}

export interface CredentialsaResponse {
    CREDENTIALS_SSO: {
        status: number;
        data: {
            AreaPemasaran: string;
            JenisPendaftaran: string;
            JenisProduk: string;
            Kbli: string;
            MerekDagang: string;
            NamaPJ: string;
            EmailPJ: string;
            NomorTelpPJ: string;
            Nib: string;
            Token: string;
        }
    }
}


export const credentialsSSO = createAsyncThunk(
    "credentialsSSO",
    async (data: {
        CREDENTIALS_SSO: {
            Credentials: string
        }
    }, thunkAPI) => {
        const config = {
            method: "post",
            url: "saliha/sso/credentials",
            data,
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data);
            }
        );
    }
);

export const userInfoSaliha = createAsyncThunk(
    "userInfoSaliha",
    async (data: { access_token: string }, thunkAPI) => {
        const config = {
            method: "post",
            url: "saliha/sso/userinfo",
            data: data,
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data);
            }
        );
    }
);

export const signUpSaliha = createAsyncThunk(
    "signUpSaliha",
    async (data: SignUpSalihaRequest, thunkAPI) => {
        const config = {
            method: "post",
            url: "auth/sign-up-saliha",
            data: data,
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.REGISTER.data);
            }
        );
    }
);

export const signInSaliha = createAsyncThunk(
    "signInSaliha",
    async (data: SignInSalihaRequest, thunkAPI) => {
        const config = {
            method: "post",
            url: "auth/sign-in",
            data: data,
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.REGISTER.data);
            }
        );
    }
);


const SalihaAuthSlice = createSlice({
    name: "SalihaAuthSlice",
    initialState: {
        dataUserInfo: {} as UserInfoSalihaResponse,
        dataSignUp: {} as SignUpSalihaResponse,
        dataSignIn: {} as SignInSalihaResponse,
        dataCredentials: {} as CredentialsaResponse,

        isFetching: false,

        isSuccessUserInfo: false,
        isSuccessSignUp: false,
        isSuccessSignIn: false,
        isSuccessCredentials: false,

        isError: false,
        errorMessage: "" as string,
    },
    reducers: {
        clearState: (state, action) => {
            state.isFetching = false;
            state.isSuccessSignUp = false;
            state.isSuccessSignIn = false;
            state.isSuccessCredentials = false;
            state.isError = false;
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        // userInfoSaliha
        builder.addCase(userInfoSaliha.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.dataUserInfo = payload;
            state.isSuccessUserInfo = true;
            return state;
        });
        builder.addCase(userInfoSaliha.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(userInfoSaliha.pending, (state, action) => {
            state.isFetching = true;
        });

        // signUpSaliha
        builder.addCase(signUpSaliha.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.dataSignUp = payload;
            state.isSuccessSignUp = true;
            return state;
        });
        builder.addCase(signUpSaliha.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(signUpSaliha.pending, (state, action) => {
            state.isFetching = true;
        });

        // signInSaliha
        builder.addCase(signInSaliha.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.dataSignIn = payload;
            state.isSuccessSignIn = true;
            return state;
        });
        builder.addCase(signInSaliha.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(signInSaliha.pending, (state, action) => {
            state.isFetching = true;
        });

        // credentials
        builder.addCase(credentialsSSO.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.dataCredentials = payload;
            state.isSuccessCredentials = true;
            return state;
        });
        builder.addCase(credentialsSSO.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(credentialsSSO.pending, (state, action) => {
            state.isFetching = true;
        });
    },
});

export const { clearState } = SalihaAuthSlice.actions;
export default SalihaAuthSlice.reducer;
